import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card, CardBody, CardFooter } from '@components/card/card';
import { Form, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch } from '@store/hooks';
import { useNavigate } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import { TreeSelect } from 'antd';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
import confirmAction from '@components/Shared/Alert/confirmAction';
import { addArReceipts, getArReceiptsList } from '@store/Finance/AR/ArReceipts/ArReceiptsSlice';
import useGetBankAccountsList from '@hooks/Finance/BankAccounts/useGetBankAccountsList';
import useGetReceiptsTypeList from '@hooks/Finance/ArReceipts/useGetReceiptsTypeList';
import { AddApPaymentsSchema, AddArReceiptsSchema } from '../../../../ValidationForm/validationSchema';
// import useGetBranchOrgWithPermission from '@hooks/NTX/Organization/useGetBranchOrgWithPermission';
import { useState } from 'react';
import NeatixModal from '@components/Modal/NeatixModal';
import ArScheduleList from '../ArScheduleList';
import useGetCustomersList from '@hooks/NTX/Peoples/useGetCustomersList';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { receiptTypeEnum } from '../receiptTypeEnum';
import ChooseType from './ChooseType';
import { useDailyRate } from '@hooks/Finance/DailyRates/useDailyRate';
import ReceiptDetailsCard from './ReceiptDetailsCard';

const Add = () => {
  const [showModal, setShowModal] = useState(true);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { Currency, loading, error } = useLookupCurrency();
  const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();
  const { treeCustomerData, error: error2, loading: loading2 } = useGetCustomersList();
  const { PaymentMethodList, error: error3, loading: loading3 } = useGetPaymentMethod();
  const { groupedOptions, OptionsBankAccounts , error: error4, loading: loading4 } = useGetBankAccountsList();
  const { ReceiptsTypeList } = useGetReceiptsTypeList();

  //#region Formik
  const formik = useFormik({
    initialValues: {
      customerBankAccount: '',
      receiptType: receiptTypeEnum.Standard,
      depositDate: new Date().toISOString().split('T')[0],
      bankAccountId: '',
      depositMethodId: '',
      amount: 0,
      currencyCode: 'SAR',
      currencyConversionRate: 1,
      peopleId: null,
      organizationId: '',
      dibetMemoTransactionId: '',
      preReceiptId: '',
      description: '',

      scheduleList: [
        {
          arReceiptScheduleId: '',
          amount: 0
        }
      ]
    },

    enableReinitialize: true,
    validationSchema: AddArReceiptsSchema(t),

    onSubmit: async values => {
      const isConfirmation = await confirmAction('هل أنت متأكد من أنك تريد إضافة هذا القبض؟');
      if (!isConfirmation) {
        formik.setSubmitting(false);
        return;
      }

      const totalAmount = values.scheduleList?.reduce((sum: any, line: any) => sum + line.amount, 0);

      dispatch(
        addArReceipts({
          customerBankAccount: values.customerBankAccount,
          bankAccountId: values.bankAccountId || null,
          depositMethodId: values.depositMethodId || null,
          depositDate: values.depositDate,
          amount: [receiptTypeEnum.PreReceipt, receiptTypeEnum.Refund].includes(values.receiptType)
            ? values.amount
            : totalAmount,
          currencyCode: values.currencyCode,
          currencyConversionRate: rate,
          peopleId: values.peopleId,
          organizationId: values.organizationId,
          receiptType: values.receiptType,
          dibetMemoTransactionId: values.dibetMemoTransactionId || null,
          preReceiptId: values.preReceiptId || null,
          description: values.description?.trim() || '',

          scheduleList: [receiptTypeEnum.PreReceipt, receiptTypeEnum.Refund].includes(values.receiptType)
            ? []
            : values.scheduleList.map((item: any) => ({
                arReceiptScheduleId: item.arReceiptScheduleId,
                amount: item.amount
              }))
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            dispatch(getArReceiptsList());
            navigate('/AR/ArReceipts', { replace: true });
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });
  const { values, handleChange: formikhandleChange, errors, touched, setFieldValue, setFieldTouched } = formik;
  //#endregion

  const {
    rate,
    loading: loadingRate,
    error: errorRate,
    refetch
  } = useDailyRate({
    currencyCode: values.currencyCode,
    date: values.depositDate
  });

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: ':moduleHome'
          },
          {
            name: 'Receipts',
            link: '/AR/ArReceipts'
          },
          {
            name: 'سند إستلام جديد',
            link: null
          }
        ]}
        PageName='سند إستلام جديد'
      />

      <Card>
        <Loading
          loading={loading || loading1 || loading2 || loading3 || loading4}
          error={error || error1 || error2 || error3 || error4}
        >
          <Form onSubmit={formik.handleSubmit}>
            <CardBody>
              <div className='row'>
                {/* نوع القبض */}
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('ReceiptType')}</label>
                    <Form.Select
                      disabled
                      className='form-select'
                      name='receiptType'
                      onChange={formikhandleChange}
                      value={values.receiptType || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {ReceiptsTypeList?.map((item, idx) => (
                        <option key={idx} value={item.id}>
                          {i18n.language === 'en' ? item.name : item.name2}
                        </option>
                      ))}
                    </Form.Select>
                    <div className='text-danger small'>{touched.receiptType && formik.errors.receiptType}</div>
                  </div>
                </div>

                {/* {t('العميل')} */}
                <div className='col-lg-3 '>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Customer')}</label>
                    <TreeSelect
                      disabled
                      showSearch
                      className='w-100'
                      treeLine
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      allowClear
                      treeDefaultExpandAll={false}
                      value={values.peopleId}
                      onChange={option => {
                        formik.setFieldValue('peopleId', option === null ? null : option);
                      }}
                      treeData={treeCustomerData}
                      treeNodeFilterProp='title'
                    />
                    <div className='text-danger small'>{touched.peopleId && errors.peopleId}</div>
                  </div>
                </div>

                {/* ('الفرع') */}
                <div className='col-lg-3  '>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Branch')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading3}
                      isSearchable={true}
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
                      onChange={(option: any) => setFieldValue('organizationId', option === null ? null : option.value)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>{touched.organizationId && errors.organizationId}</div>
                  </div>
                </div>

                {/* التاريخ */}
                <div className='col-lg-3  '>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Date')}</label>
                    <Form.Control
                      className='form-control'
                      type='date'
                      name='depositDate'
                      onChange={formikhandleChange}
                      value={values.depositDate || ''}
                    />
                    <div className='text-danger small'>{touched.depositDate && errors.depositDate}</div>
                  </div>
                </div>

                {![receiptTypeEnum.ApplyDebitMemo, receiptTypeEnum.ApplyPreReceipt].includes(values.receiptType) && (
                  <>
                    {/* طريقة الدفع */}
                    <div className='col-lg-3 '>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('PaymentMethod')}</label>
                        <Form.Select
                          className='form-select'
                          name='depositMethodId'
                          onChange={formik.handleChange}
                          value={formik.values.depositMethodId || ''}
                        >
                          <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                          {PaymentMethodList?.map((item: any, idx: number) => (
                            <option key={++idx} value={item.id}>
                              {i18n.language === 'en' ? item.name : item.name2}
                            </option>
                          ))}
                        </Form.Select>
                        <div className='text-danger small'>{touched.depositMethodId && errors.depositMethodId}</div>
                      </div>
                    </div>

                    {/* bankAccountId */}
                    <div className='col-lg-3 '>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('Bank / Fund')}</label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable={true}
                          isClearable
                          options={OptionsBankAccounts}
                          value={OptionsBankAccounts?.find((f: any) => f?.value === formik.values.bankAccountId)}
                          onChange={(option: any) =>
                            setFieldValue('bankAccountId', option === null ? null : option?.value)
                          }
                          placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                        />
                        <div className='text-danger small'>{touched.bankAccountId && errors.bankAccountId}</div>
                      </div>
                    </div>

                    {/* ('Currency') */}
                    <div className='col-lg-3'>
                      <div className='form-group mb-3'>
                        <label className='form-label'> {t('Currency')} </label>
                        <Form.Select
                          className='form-select'
                          name='currencyCode'
                          onChange={formikhandleChange}
                          value={values.currencyCode || ''}
                        >
                          <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                          {Currency &&
                            Currency?.map((item: any, idx: number) => (
                              <option key={++idx} value={item.currencyCode}>
                                {item.description}
                              </option>
                            ))}
                        </Form.Select>
                        <div className='text-danger small'>{touched.currencyCode && errors.currencyCode}</div>
                      </div>
                    </div>

                    {/* ('معدل العملة') */}
                    <div className='col-lg-3 '>
                      <div className='form-group mb-3'>
                        <label className='form-label'> {t('CurrencyConversionRate')} </label>
                        <InputGroup>
                          <Form.Control
                            className='form-control text-center'
                            type='text'
                            readOnly
                            value={loadingRate ? '' : errorRate ? 'فشل التحميل' : rate}
                            placeholder={loadingRate ? 'جاري التحميل...' : ''}
                          />

                          {loadingRate && (
                            <InputGroup.Text>
                              <div className='spinner-border spinner-border-sm text-primary'></div>
                            </InputGroup.Text>
                          )}

                          {errorRate && !loadingRate && (
                            <InputGroup.Text style={{ padding: '0' }}>
                              <button
                                type='button'
                                className='btn btn-outline-warning h-100 px-2'
                                onClick={refetch}
                                title='إعادة تحميل سعر الصرف'
                              >
                                <i className='fas fa-redo'></i>
                              </button>
                            </InputGroup.Text>
                          )}
                        </InputGroup>

                        {errorRate && !loadingRate && (
                          <small className='text-warning mt-1 d-block text-center'>
                            <i className='fas fa-exclamation-circle me-1'></i>
                            تعذر تحميل السعر
                            <button
                              type='button'
                              className='btn btn-link btn-sm p-0 text-warning ms-1'
                              onClick={refetch}
                            >
                              (إعادة المحاولة)
                            </button>
                          </small>
                        )}
                      </div>
                    </div>
                    {/* الوصف */}
                    <div className='col-lg-12'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('Description')}</label>
                        <Form.Control
                          as='textarea'
                          rows={1}
                          className='form-control'
                          name='description'
                          value={values.description || ''}
                          onChange={formikhandleChange}
                          onBlur={() => setFieldTouched('description', true)}
                          placeholder={i18n.language === 'ar' ? 'اكتب الوصف...' : 'Write description...'}
                        />
                        <div className='text-danger small'>{touched.description && (errors as any).description}</div>
                      </div>
                    </div>
                  </>
                )}

                {values.receiptType === receiptTypeEnum.PreReceipt && (
                  <div className='col-lg-3'>
                    <div className='form-group mb-3'>
                      {/* <label className='form-label'>{t('PreReceiptAmount')}</label> */}
                      <label className='form-label'>{t('المبلغ')}</label>
                      <Form.Control
                        className='form-control text-center fs-5 fw-bold text-theme'
                        type='text'
                        autoComplete='off'
                        name='amount'
                        onChange={formikhandleChange}
                        value={values.amount || ''}
                        onInput={e => {
                          const input = e.target as HTMLInputElement;
                          input.value = input.value.replace(/[^0-9]/g, '');
                        }}
                      />
                      <div className='text-danger small'>{errors.amount}</div>
                    </div>
                  </div>
                )}
              </div>
            </CardBody>

            <CardFooter className='mt-0 p-0'>
              <ReceiptDetailsCard
                receiptType={values.receiptType}
                Id={
                  [receiptTypeEnum.ApplyDebitMemo, receiptTypeEnum.Refund].includes(values.receiptType)
                    ? values.dibetMemoTransactionId
                    : values.receiptType === receiptTypeEnum.ApplyPreReceipt
                    ? values.preReceiptId
                    : null
                }
              />

              <hr className='my-4' />

              <div hidden={[receiptTypeEnum.PreReceipt, receiptTypeEnum.Refund].includes(values.receiptType)}>
                <ArScheduleList formik={formik} />
              </div>

              <div className=' text-center my-3'>
                <button
                  disabled={formik.isSubmitting}
                  type='submit'
                  className='btn btn-lg me-1 btn-theme mb-1 rounded-2'
                >
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fas fa-lg fa-fw me-2 fa-credit-card'></i>
                  )}
                  {t('Receipt')}
                </button>
                <button
                  type='button'
                  className='btn btn-lg me-1 btn-default mb-1 rounded-2'
                  onClick={() => navigate('/AR/ArReceipts', { replace: true })}
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </CardFooter>
          </Form>
        </Loading>
      </Card>

      <NeatixModal
        show={showModal}
        setShow={setShowModal}
        size='xl'
        bodyClassName='p-0'
        showHeader={false}
        keyboard={false}
        backdrop={true}
        centered
      >
        <Card>
          <ChooseType formik={formik} onClose={() => setShowModal(false)} />
        </Card>
      </NeatixModal>
    </>
  );
};

export default Add;
